import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { provideNzIconsPatch } from "ng-zorro-antd/icon";
import { CheckCircleTwoTone, ThunderboltFill } from '@ant-design/icons-angular/icons';
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { KeyValue } from "@angular/common";
import { WebhookConfiguration } from "../webhook-interfaces/configuration";
import { WebHookCommonServices } from "../webhook-services/webhook-commom.services";



@Component({
    selector: 'marketplace-viewer',
    templateUrl: './marketplace-viewer.component.html',
    standalone: false,
    styleUrl:'./marketplace-viewer.component.scss',
    providers: [provideNzIconsPatch([CheckCircleTwoTone,ThunderboltFill])]
})

export class MarketPlaceViewerComponent implements OnInit, OnDestroy {
    panel: {id:string,name:string,active:boolean,disabled:boolean}[] = [];
    //formValidationList: {id:string, form:FormGroup<any>}[] =[]
    variables:Variable[] = [];
    //node: NodeViewModel;
    //connection:ConnectorModel;
    //flowData: FlowData;
    configuration:WebhookConfiguration =null;
    layoutMap: { [panelId: string]: any } = {};
    layoutMapPanel: { [tabId: string]: any } = {};
    tabs:{id:string,name:string,disabled:boolean}[] = [];
    //configurations:{name:string, layout:WebhookConfiguration}[] = [];
    createdError: boolean  = false;
    form:FormGroup;
    createdInputVariable: boolean;
    createdConditionalExecution: boolean;
    //nodeToConnection:NodeViewModel;
    isNew:boolean = false;

    constructor(
            private fb:NonNullableFormBuilder, 
            private commomServices:WebHookCommonServices
        
        )  {

            this.configuration= {
                    "tabs": [
                        {
                            "id": "general",
                            "name": "Geral",
                            "icon": "setting",
                            "themeIcon": "twotone",
                            "twotoneColor": "#52c41a",
                            "disabled": false
                        },
                        {
                            "id": "Shopee",
                            "name": "Shopee",
                            "icon": "custom:shopee",
                            "disabled": true,
                            "themeIcon": null,
                            "twotoneColor": null,
                        },
                        {
                            "id": "meli",
                            "name": "Mercado Livre",
                            "icon": "custom:meli",
                            "themeIcon": null,
                            "twotoneColor": null,
                            "disabled": true
                        }
                    ],
                    "panels": [
                        {
                            "id": "main",
                            "name": "Principal",
                            "active": true,
                            "disabled": false,
                            "tab": "general"
                        },
                        {
                            "id": "shopeemain",
                            "name": "Dados Shopee",
                            "active": true,
                            "disabled": false,
                            "tab": "Shopee"
                        },
                        {
                            "id": "melimain",
                            "name": "Dados MercadoLivre",
                            "active": true,
                            "disabled": false,
                            "tab": "meli"
                        }
                    ],
                    "fields": [
                        {
                            "field": "codeproduct",
                            "type": "search",
                            "label": "Cód. Produto",
                            "placeholder": "Cód. Produto",
                            "panel": "main",
                            "col": 0,
                            "row": 0,
                            "colSpan": 24,
                            "showKey": true,
                            "searchProperties": {
                                "entityName": "Mktpproducts",
                                "fields": {
                                    "keyField": "CODEPRODUCT",
                                    "valueField": "NAME"
                                }
                            },
                        },
                        {
                            "field": "usaMeli",
                            "type": "switch",
                            "label": "Mercado Livre",
                            "placeholder": "Mercado Livre",
                            "panel": "main",
                            "col": 1,
                            "row": 1,
                            "colSpan": 6,
                            "onChange":" if ( this.getValue('usaMeli')){this.context.configuration.tabs.find(d=>d.id=='meli').disabled=false;}else{this.context.configuration.tabs.find(d=>d.id=='meli').disabled=true;}"
                        },
                         {
                            "field": "usaShopee",
                            "type": "switch",
                            "label": "Shopee",
                            "placeholder": "Shopee",
                            "panel": "main",
                            "col": 0,
                            "row": 1,
                            "colSpan": 6,
                            "onChange":" if ( this.getValue('usaShopee')){this.context.configuration.tabs.find(d=>d.id=='Shopee').disabled=false}else{this.context.configuration.tabs.find(d=>d.id=='Shopee').disabled=true}"
                        },
                        {
                            "field": "name",
                            "type": "text",
                            "label": "Descrição",
                            "placeholder": "Descrição",
                            "panel": "main",
                            "col": 0,
                            "row": 2,
                            "colSpan": 24,
                            "showFormula": true,
                            "minRows": 10
                        },
                        {
                            "field": "description",
                            "type": "richedtext",
                            "label": "Descrição",
                            "placeholder": "Descrição",
                            "panel": "main",
                            "col": 0,
                            "row": 3,
                            "colSpan": 24,
                            "minRows": 10
                        },
                        {
                            "field": "marcas",
                            "type": "querySelect",
                            "label": "Marcas",
                            "placeholder": "Marcas",
                            "tooltip": "Marcas",
                            "panel": "shopeemain",
                            "col": 0,
                            "row": 1,
                            "colSpan": 24,
                            "showKey": true,
                            "condition": "SELECT  top 100 BRANDID VALUE , BRANDNAME LABEL FROM MKTPSHOPEEBRAND"
                        },
                        {
                            "field": "melicat",
                            "type": "querySelect",
                            "label": "Categorias",
                            "placeholder": "Categorias",
                            "tooltip": "Categorias",
                            "panel": "melimain",
                            "col": 0,
                            "row": 1,
                            "colSpan": 24,
                            "showKey": true,
                            "condition": "SELECT  top 100 BRANDID VALUE , BRANDNAME LABEL FROM MKTPSHOPEEBRAND"
                        }
                        
                    ]
                }
        
    }

    getFieldsByPanelId(panelId:string){
        return this.configuration.fields.filter(data=>data.panel==panelId);
    }


     ngOnDestroy(): void {
        this.form = null;
    }

    transformPanelMap(){
        this.panel.forEach(panel => {
            this.layoutMap[panel.id] = this.computeLayout(panel.id);
        });
    }

    transformTabMap(){
        this.tabs.forEach(tab => {
            this.layoutMapPanel[tab.id] = this.computeLayoutTab(tab.id);
        });
    }

    computeLayoutTab(tabId: string) {
       this.configuration.panels.sort((a,b)=>{
            if ( a.order > b.order ) { return 1;}
            if ( a.order < b.order ) { return -1;}
            return 0;

        });

        const grouped: { [id: string]: any[] } = {};
        let i = 0;
        for (const item of this.configuration.panels) {
            if (item.tab !== tabId) continue;
            let order = item.order==null? i++ : item.order;
            if (!grouped[order]) {
                grouped[order] = [];
            }

            grouped[order].push(item);
        }
        
        return grouped;
    }
    

    computeLayout(panelId: string) {
        const data = this.configuration.fields
            .filter(d => d.panel === panelId)
            .reduce((acc, item) => {
            acc[item.row] = acc[item.row] || [];
            acc[item.row].push(item);
            return acc;
            }, {} as { [row: number]: any[] });

        Object.keys(data).forEach(row => {
            data[+row].sort((a, b) => a.col - b.col);
        });
        
        return data;
    }


    initConfiguration(){
        this.configuration = JSON.parse(JSON.stringify(this.configuration));
        //this.configurations = this.data.configurations;
    }

    ngOnInit(): void {
        
        this.initConfiguration();
        this.getTab();
        this.getPanel();
        this.transformTabMap();
        this.transformPanelMap();
        
        this.form =  this.fb.group({});
        this.panel.forEach(p=>{
            this.getFieldsByPanelId(p.id).forEach(each=>{
                this.commomServices.createControl(each,this.form);
            });
            //this.formValidationList.push({id:p.id,form:form});
        });
        
    }
    
    
    
    


    getLayout(panelid:string) {
        var data =  this.configuration.fields.filter(d=>d.panel == panelid)
        .reduce((acc, item) => {
            acc[item.row] = acc[item.row] || [];
            acc[item.row].push(item);
            return acc;
        }, {} as { [row: number]: any[] });

        for (const row in data) {
            data[row].sort((a, b) => a.col - b.col);
        }

        return data;
    }
    
    getPanel(){
        this.panel =  this.configuration.panels;
    }

    getTab(){
        this.tabs =  this.configuration.tabs;
    }


    drawerWidth = 400;

    functionFieldtrackByFn( index: number, item) {
        return item.field;
    }

    functionTabletrackByFn(index,  item: KeyValue<string, any>) {
        return item.key;
    }
}
